<template>
    <div class="home d-flex flex-column justify-content-start">

        <div class="row h-100">
            <div class="col-md-9 h-100 overflow-auto">

                <dashboard-feed-top
                :filterButtons="buttons"
                :feedFilter="feedFilter"
                :locked="showFirstTasks"
                @filterChanged="feedFilter = $event">
                </dashboard-feed-top>

                <!-- <dashboard-starting-tasks v-if="showFirstTasks && !skipFirstTasks || !skipFirstTasks" v-on:forceSkipTasks="forceSkipTasks"></dashboard-starting-tasks> -->
                <dashboard-starting-tasks v-if="showFirstTasks" v-on:forceSkipTasks="forceSkipTasks" v-on:skipTasksForNow="skipTasksForNow"></dashboard-starting-tasks>
                <dashboard-feed v-if="showFeed" :cards="feedCards" :filter="feedFilter"></dashboard-feed>


            </div>
        <div class="col-md-3">

        <dashboard-side-panel></dashboard-side-panel>

        </div>
      </div>


    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import DashboardFeedTop from '../dashboard/FeedTop'
    import DashboardFeed from '../dashboard/Feed'
    import DashboardStartingTasks from '../dashboard/StratingTasks'
    import DashboardSidePanel from '../dashboard/SidePanel'

    export default {
        created:function(){
            this.showStartingTasks();

            // redires user if needed
            if(this.accessPermissionFilter(['viewer'])){
                this.$router.push({name: 'calendar'})
            }
        },
        data: function() {
            return {
                skipFirstTasks: false,
                showFirstTasks: false,
                showFeed: true,
                gotCompanySettings: false,
                feedFilter: 'today',
                buttons: [
                    {
                        label: 'Today',
                        icon: 'ico-calendar',
                        term: 'today'
                    },
                    // {
                    //     label: 'Performance',
                    //     icon: 'ico-notes',
                    //     term: 'performance'
                    // },
                    // {
                    //     label: 'Check-ins',
                    //     icon: 'ico-check-in2',
                    //     term: 'checkins'
                    // },
                    // {
                    //     label: 'Sales',
                    //     icon: 'ico-check-in',
                    //     term: 'sales'
                    // }
                ],
                feedCards:[
                    {
                        category: 'today',
                        type: 'newota',
                        otaId: 1,
                        visible: true
                    },
                    {
                        category: 'today',
                        type: 'taskscompleted',
                        visible: false
                    },
                    {
                        category: 'today',
                        type: 'news',
                        title: 'Qatar: Portugal entre os países isentos de Visa.',
                        subTitle: 'Medida visa atrair mais turistas ao país e tem efeito imediato.',
                        date: '16 DE AGOSTO DE 2017, POR PUBLITURIS',
                        image: 'https://img.rt.com/files/2017.06/original/5935126ec36188cb648b459b.jpg',
                        visible: false
                    },
                    {
                        category: 'performance',
                        type: 'occupancyreport',
                        visible: false
                    },
                    {
                        category: 'today',
                        type: 'multi',
                        nrAlerts: 15,
                        nrPickups: 0,
                        nrBookings: 5,
                        visible: false
                    },
                    {
                        category: 'performance',
                        type: 'departures',
                        visible: true
                    },
                    {
                        category: 'today',
                        type: 'weather',
                        label: 'Sunny Days',
                        overview: {
                            temperature: 30,
                            percipitation: 0,
                            humidity: 27,
                            windSpeed: 13,
                        },
                        visible: true
                    },
                    {
                        category: 'sales',
                        type: 'salesdaily',
                        visible: false
                    },
                    {
                        category: 'checkins',
                        type: 'missedcheckins',
                        visible: false
                    },
                    {
                        category: 'performance',
                        type: 'occupancy',
                        productName: 'Caves & Coastline',
                        date: 'Tomorrow, 10:30',
                        percentAvaliable: '20',
                        ticketRemaining: '10',
                        visible: false
                    }
                ]
            }
        },
        methods:{
            ...mapActions([
                'initSettings'
            ]),
            forceSkipTasks: function(){
                this.skipFirstTasks = true;
            },
            async showStartingTasks(){
                let vm = this;

                //checks if user pressed "Skip for now"

                this.initSettings().then(function(data){
                    try {

                        if( vm.getCompanySettings.settingProfileEdited &&
                            vm.getCompanySettings.settingResourceAdd &&
                            vm.getCompanySettings.settingProductAdded &&
                            vm.getCompanySettings.settingAgentAdded || vm.getSkipStartTasks){

                            vm.showFeed = true
                            vm.showFirstTasks = false

                            // read emoji card status shows if never showed and sends to API that it was shown
                            if(!vm.getCompanySettings.feedShown){
                                vm.markEmojiCardShowed();
                                vm.showEmojiCard();
                            }

                        } else {
                            // vm.showFirstTasks = true
                            // vm.showFeed = false
                            // force show feed
                            vm.showFirstTasks = false
                            vm.showFeed = true
                        }
                    } catch (error) {
                        vm.$toasted.error(error);
                    }

                })
            },
            markEmojiCardShowed: function(){
              axios.post('/api/supplier/SetFeedShown', { id: this.account.supplierId }).then((response) => {
                    if (response && response.status === 200) {

                    }
              })
            },
            showEmojiCard: function(){
              for (let card of this.feedCards) {
                if(card.type == 'taskscompleted' && !this.getSkipStartTasks){
                  card.visible = true;
                }
              }
            },
            skipTasksForNow: function(){
                this.showStartingTasks();
            }
        },
        computed:{
            ...mapGetters([
                'getCompanySettings',
                'account',
                'getSkipStartTasks'
            ]),
        },
        components: {
          DashboardFeedTop,
          DashboardFeed,
          DashboardSidePanel,
          DashboardStartingTasks
        }
    }
</script>

<style scoped lang="scss">
  @import '../../assets/scss/_variables.scss';

  //this is a qucick fix, should be removed
  .dirtyScroll{
    // height: 94vh;
    overflow-y: auto;
  }

</style>



// WEBPACK FOOTER //
// Home.vue?5ecccf07